'use client';

import { useEffect, useState } from 'react';
import { SectionLabel } from '@/components/shared/SectionLabel';
import { getTestimonials } from '@/lib/actions/testimonials';
import { TestimonialCarousel } from './TestimonialCarousel';

export function TestimonialSection() {
  const [testimonials, setTestimonials] = useState<any[]>([]);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    getTestimonials().then((data) => {
      if (cancelled) return;
      setTestimonials(data);
      setReady(true);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!ready || testimonials.length === 0) {
    return null;
  }

  return (
    <section className="py-20 md:py-28 bg-light/30 overflow-hidden">
      <div className="max-w-[1170px] mx-auto px-5 md:px-[40px]">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6">
          <div className="max-w-2xl">
            <SectionLabel text="What Our Clients Say!" />
            <h2 
              className="text-[30px] md:text-[38px] font-bold text-navy leading-tight font-heading"
            >
              Trust from our <span className="text-primary">valuable partners</span>
            </h2>
          </div>
        </div>

        <TestimonialCarousel testimonials={testimonials} />
      </div>
    </section>
  );
}
